// migration-allow(composition-import): the sidebar renders the add-to-library host
import { AddToLibraryButtonHost as AddToLibraryButton } from '@/composition/hosts/templates/add-to-library-button/add-to-library-button-host';
import { TypographyPBold } from '@heidi/design-system/typography';
import { communityTemplateDetailsMessages, ShareActions } from '@heidi/templates';
import type { DetailedPublicTemplateResponse } from '@heidi/templates/contracts';
import { FormattedMessage } from 'react-intl';
import { TemplateTags } from './TemplateTags';

interface DetailsSidebarProps {
  getUrlWithoutHash: () => string;
  onBadgeClick: (type: 'specialty' | 'category') => void;
  onCopyLinkClick: () => void;
  template: DetailedPublicTemplateResponse | undefined;
  templateAlreadyExists: boolean;
}

export const DetailsSidebar = ({
  getUrlWithoutHash,
  onBadgeClick,
  onCopyLinkClick,
  template,
  templateAlreadyExists,
}: DetailsSidebarProps) => {
  return (
    <div className="hidden w-full max-w-48 flex-col gap-8 lg:sticky lg:top-3 lg:flex lg:self-start">
      <AddToLibraryButton
        templateId={template?.template_id}
        templateAlreadyExists={templateAlreadyExists}
        size="md"
      />

      <div className="flex flex-col gap-2">
        <TypographyPBold>
          <FormattedMessage {...communityTemplateDetailsMessages.tagsHeading} />
        </TypographyPBold>
        <TemplateTags template={template} onBadgeClick={onBadgeClick} />
      </div>

      <div className="flex flex-col gap-2">
        <TypographyPBold>
          <FormattedMessage {...communityTemplateDetailsMessages.shareHeading} />
        </TypographyPBold>
        <ShareActions
          getUrlWithoutHash={getUrlWithoutHash}
          onCopyLinkClick={onCopyLinkClick}
        />
      </div>
    </div>
  );
};
